import { useTranslation } from 'react-i18next';

const useSurveyTemplateOptions = () => {
  const { t } = useTranslation('scout');

  return [
    { label: t('standard'), value: 'Standard' },
    { label: t('other'), value: 'Other' },
  ];
};

export default useSurveyTemplateOptions;
